module.exports = __webpack_public_path__ + "img/ship.21f24f91.png";